/** 加密处理 */
import { sm4 } from 'sm-crypto';
import SortKeys from 'sort-keys';
import { Sha256 } from '@aws-crypto/sha256-js';

const KEY = 'e4dd41fd138867c3665492702fe277eb';

/**
 * 国密4加密
 * @param {String} txt
 * @returns
 */
export const sm4Encrypt = (txt: string) => {
  return sm4.encrypt(txt, KEY);
};

/**
 * 国密4解密
 * @param {String} txt
 * @returns
 */
export const sm4Decrypt = (txt: string) => {
  return sm4.decrypt(txt, KEY);
};

/**
 * 移除obj中值为null的key
 * @param {*} data
 * @returns
 */
export const removeNullUndefinedKey = (data: Record<string, any>) => {
  if (Object.prototype.toString.call(data) === '[object Object]') {
    return Object.keys(data).reduce((pre, k) => {
      const value = data[k];
      if (!(Object.is(value, null) || Object.is(value, undefined))) {
        // 不为null
        if (Object.prototype.toString.call(value) === '[object Object]') {
          pre[k] = removeNullUndefinedKey(value);
        } else {
          pre[k] = value;
        }
      }
      return pre;
    }, {} as Record<string, any>);
  }
  return data;
};

export const paramsEncrypt = async (params: any) => {
  try {
    // 深拷贝,如果参数值为null，使用空值判断??处理成空字符
    let newParams = JSON.parse(JSON.stringify(params ?? ''));
    if (!newParams) {
      return {
        sm4Str: '',
        signature: '',
        params,
      };
    }
    let paramsStr = newParams;
    if (Object.prototype.toString.call(newParams) === '[object Object]') {
      // 0. 剔除参数值为null的所有key
      newParams = removeNullUndefinedKey(newParams);
      // 1.增加时间戳字段，然后对非数组对象需要进行第一级key按字典序排序
      newParams = {
        timeStamp: +new Date(),
        ...newParams,
      };
      paramsStr = JSON.stringify(SortKeys(newParams));
    } else {
      paramsStr = JSON.stringify(newParams);
    }
    // 2. 字母全部转小写
    paramsStr = paramsStr.toLocaleLowerCase();
    // console.log('paramsStr：', paramsStr);
    // 3. 进行国密4加密
    const sm4Str = sm4Encrypt(paramsStr);
    // console.log('sm4：', sm4Str);
    // 4. sha256摘要加密
    const hash = new Sha256();
    hash.update(sm4Str);
    const uint8Array = await hash.digest();
    // 5. Uint8Array转为十六进制字符串
    const signature = Array.prototype.map.call(uint8Array, x => ('00' + x.toString(16)).slice(-2)).join('');
    // console.log('sha256：', signature);
    return {
      sm4Str,
      signature,
      params: newParams,
    };
  } catch (e) {
    return Promise.reject(e);
  }
};
